import { RSCUserPrivileges } from './RSCUserPrivileges';
import { RSCBase } from './base/RSCBase';

export class RSCPayrollAccount extends RSCBase {
  id!: number;

  get Id() {
    return this?.id || 0;
  }

  protected override _afterFill(data: any) {}

  override toJSON(): any {
    return {
      id: this.id,
    };
  }
}
